import { Component, Input, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';

import { Organization } from '../../shared/models/organization.model';
import { ee, profilePics } from '../../shared/constants';
import { ToastComponent } from '../../shared/toast/toast.component';
import { AuthService } from '../../services/auth.service';
import { OrganizationService } from '../../services/organization.service';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-organization',
  templateUrl: './organization.component.html',
  styleUrls: ['./organization.component.scss'],
  standalone: false
})
export class OrganizationComponent implements OnInit {
  auth = inject(AuthService);
  private router = inject(Router);
  private organizationService = inject(OrganizationService);
  toast = inject(ToastComponent);


  @Input() organization: Organization;

  isDetailsPage = false;
  isEditOrganizationModalVisible = false;
  field = '';
  profilePics = profilePics;

  ngOnInit(): void {
    if (!this.organization) {
      this.toast.setMessage('This organization does not exists!', 'danger');
      this.router.navigate(['/organizations']);
      return;
    }
    if (this.router.url.includes('organization/')) {
      this.isDetailsPage = true;
    }
  }

  toggleEditOrganizationModal(field: string): void {
    this.isEditOrganizationModalVisible = true;
    this.field = field;
    ee.emit('showEditOrganizationModal', field);
  }

  deleteOrganization(organization: Organization): void {
    if (window.confirm(`Are you sure you want to delete ${organization.name}?`)) {
      this.organizationService.delete(organization)
        .pipe(finalize(() => this.router.navigate(['/organizations'])))
        .subscribe({
          next: res => this.toast.setMessage('Organization deleted successfully.', 'success'),
          error: err => this.toast.setMessage(err.error.message, 'danger')
        });
    }
  }

}
